/**
 * The visit-scoped list endpoints answer with a plain array; the profile-scoped
 * ones paginate server-side and answer with `{ data, total }`. The scope hooks
 * normalise to the paginated shape so the tables, paginators and filters above
 * them never learn which branch they are on.
 *
 * Slicing in memory is safe here because a visit-scoped list covers one visit —
 * a handful of rows, never more than a page.
 */
export interface ScopedPage<T> {
  items: T[];
  total: number;
}

export function sliceInMemory<T>(
  all: T[],
  page: number,
  rowsPerPage: number,
): ScopedPage<T> {
  const start = page * rowsPerPage;
  return { items: all.slice(start, start + rowsPerPage), total: all.length };
}
